import { z } from "zod";
import { API_KEY_BYTES, API_KEY_LABEL_MAX, API_KEY_PREFIX } from "../constants";

/** `ghk_` plus the unpadded base64url form of the random bytes (43 characters for 32 bytes). */
export const API_KEY_PATTERN = new RegExp(
  `^${API_KEY_PREFIX}[A-Za-z0-9_-]{${Math.ceil((API_KEY_BYTES * 8) / 6)}}$`,
);

export const apiKeyCreateSchema = z.strictObject({
  label: z.string().trim().min(1).max(API_KEY_LABEL_MAX),
});

/** A listed key. The key itself and its hash are never part of any view. */
export const apiKeyViewSchema = z.object({
  id: z.string(),
  label: z.string(),
  created_at: z.string(),
  last_used_at: z.string().nullable(),
  revoked_at: z.string().nullable(),
});

/** The only response that carries the plaintext key. It is shown once. */
export const apiKeyCreatedSchema = z.object({
  id: z.string(),
  label: z.string(),
  key: z.string().regex(API_KEY_PATTERN),
});

export type ApiKeyCreate = z.infer<typeof apiKeyCreateSchema>;
export type ApiKeyView = z.infer<typeof apiKeyViewSchema>;
export type ApiKeyCreated = z.infer<typeof apiKeyCreatedSchema>;
